module.exports = __webpack_public_path__ + "img/RRSS_Whatsapp.0016477c.svg";